import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '@/core/models/enum'
import { getSensorImages } from '@/api/apiService'
import { Sensor } from '../models'

export function useSensorImages(sensor: Sensor | null) {
    const sensorDbKey = sensor?.sensorDbKey ?? ''
    return useQuery({
        queryKey: [QueryKeys.SensorImages, sensorDbKey],
        enabled: !!sensorDbKey,
        queryFn: () => getSensorImages(sensorDbKey),
    })
}
